<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable fullscreen>
      <v-card>
        <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span>Medical Information of {{ data && data.name }}</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeD()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 700px" class="my-4">
          <v-row>
            <!-- <v-col cols="4" class="pa-4" v-for="i in dataItem" :key="i.id">
              <v-card class="mx-auto" max-width="344" outlined>
                <v-list-item three-line>
                  <v-list-item-content>
                    <div class="text-overline mb-4">
                      {{
                        i.pregnant != "0"
                          ? " PREGNANCY MEDICATION"
                          : "NORMAL/USUAL MEDICATION"
                      }}
                    </div>
                    <v-list-item-title class="text-h5 mb-1">
                      <div v-html="i.finding"></div>
                    </v-list-item-title>
                    <v-list-item-subtitle
                      >Greyhound divisely hello coldly
                      fonwderfully</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>

                <v-card-actions>
                  <v-btn
                    x-small
                    class="mt-1"
                    @click="view(i)"
                    outlined
                    color="green"
                    >View</v-btn
                  >
                  <v-btn
                    x-small
                    class="mt-1 mx-2"
                    @click="print(i)"
                    outlined
                    color="blue"
                    >Print</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-col> -->
            <v-col cols="12" class="d-flex justify-end mt-2 mr-2">
              <v-menu
                offset-y
                left
                transition="scale-transition"
                v-model="menu"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="blue"
                    class="rounded-lg mx-2"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    print
                  </v-btn>
                </template>

                <v-card class="pa-3" max-width="450" persistent>
                  <v-card-title class="text-h6">Print Medication</v-card-title>
                  <v-card-text>
                    <v-card
                      class="pa-2 my-2 medic"
                      style="text-align: center"
                      @click="printMeds(1)"
                      >NORMAL/USUAL MEDICATION</v-card
                    >
                    <v-card
                      v-if="buttonAlert == true"
                      class="pa-2 medic"
                      style="text-align: center"
                      @click="printMeds(2)"
                      >PREGNANCY MEDICATION</v-card
                    >
                    <v-card
                      class="pa-2 my-2 medic"
                      style="text-align: center"
                      @click="printMeds(3)"
                      >ALL MEDICATION</v-card
                    >
                  </v-card-text>
                  <!-- <v-card-actions>
                    <v-btn text color="primary" @click="menu = false"
                      >Close</v-btn
                    >
                  </v-card-actions> -->
                </v-card>
              </v-menu>
              <v-btn
                @click="AddFunction()"
                class="white--text rounded-lg"
                color="green"
                v-if="userRoleID == 3"
              >
                Add
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-data-table
                :headers="userRoleID == 3 ? headers : headers1"
                :items="dataItem"
                :items-per-page="10"
              >
                <template v-slot:[`item.index`]="{ index }">
                  {{ index + 1 }}.
                </template>
                <template v-slot:[`item.created_at`]="{ item }">
                  {{ formatDate(item.created_at) }}
                </template>
                <template v-slot:[`item.pregnant`]="{ item }">
                  {{
                    item.pregnant != "0"
                      ? "PREGNANCY MEDICATION"
                      : "NORMAL/USUAL MEDICATION"
                  }}.
                </template>

                <template v-slot:[`item.finding`]="{ item }">
                  <div v-html="item.finding"></div>
                </template>

                <template v-slot:[`item.treatment`]="{ item }">
                  <div v-html="item.treatment"></div>
                </template>

                <template v-slot:[`item.doctor`]="{ item }">
                  {{ getDoctor(item.doctorID) }}
                </template>

                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    x-small
                    class="mt-1"
                    @click="view(item)"
                    outlined
                    color="green"
                    >View</v-btn
                  >
                  <v-btn
                    x-small
                    class="mt-1 mx-2"
                    @click="print(item)"
                    outlined
                    color="blue"
                    >Print</v-btn
                  >
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>

          <v-btn color="red" outlined @click="closeD()">
            <v-icon>mdi-close-circle-outline</v-icon>
            Close
          </v-btn>

          <!-- <v-btn color="blue" class="white--text" @click="submitTarget()">
                <v-icon>mdi-check-circle</v-icon>
                Submit
              </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- delete dialog -->
    <v-dialog v-model="confirmDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to delete this information?<br /><br />
              Please note that
              <b>this action is irreversible.</b>
            </p>
          </div>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cancelDelete()"> Close </v-btn>
          <v-btn
            :disabled="isButtonLoading"
            :loading="isButtonLoading"
            color="green"
            class="white--text"
            @click="confirmDelete()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <MedicalInformation :data="medicalData" :action="action" />

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {
    MedicalInformation: () => import("./MedicalInformation.vue"),
    // viewStrategicOutcome: () => import("./ViewStrategicOutcome.vue"),
  },
  props: {
    data: null,
  },
  data() {
    return {
      options: {},
      strategicData: null,
      action: null,
      buttonAlert: false,
      desc: null,
      itemToDelete: null,
      confirmDialog: false,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      personal_details: null,
      dialog: false,
      loading: false,
      userRoleID: null,

      medicalData: null,
      id: null,
      isButtonLoading: false,
      dataItem: [],
      headers: [
        // {
        //   text: "No.",
        //   value: "index",
        //   align: "start",
        //   valign: "start",
        //   width: 50,
        //   sortable: false,
        // },
        {
          text: "Medication",
          value: "pregnant",
          align: "start",
          valign: "start",
          sortable: false,
        },

        {
          text: "Finding",
          value: "finding",
          align: "start",
          valign: "center",
          sortable: false,
        },

        {
          text: "Treatment",
          value: "treatment",
          align: "start",
          valign: "center",
          sortable: false,
        },

        {
          text: "Attending Doctor/Physician",
          value: "doctor",
          align: "start",
          valign: "center",
          sortable: false,
        },
        {
          text: "Date",
          value: "created_at",
          align: "center",
          valign: "center",
          sortable: false,
          width: 200,
        },
        {
          text: "Action",
          value: "action",
          align: "center",
          valign: "center",
          width: 200,
        },
      ],

      headers1: [
        {
          text: "No.",
          value: "index",
          align: "start",
          valign: "start",
          width: 50,
          sortable: false,
        },
        {
          text: "Pregnant",
          value: "pregnant",
          align: "start",
          valign: "start",
          sortable: false,
        },

        {
          text: "Finding",
          value: "finding",
          align: "start",
          valign: "center",
          sortable: false,
        },

        {
          text: "Attending Doctor/Physician",
          value: "doctor",
          align: "start",
          valign: "center",
          sortable: false,
        },

        {
          text: "Treatment",
          value: "treatment",
          align: "start",
          valign: "center",
          sortable: false,
        },
      ],
      docList: [],
    };
  },

  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.tab = 1;
        console.log("DataMed", data);

        this.personal_details = {
          f_name: data.f_name,
          m_name: data.m_name,
          l_name: data.l_name,
          suffix: data.suffix,
          b_date: data.b_date,
          age: data.age,
          gender: data.gender,
          contact_no: data.contact_no,
          address: data.address,
          civil_status: data.civil_status,
          occupation: data.occupation,
          spouse:
            data.civil_status.toLowerCase() == "single" ? "N/A" : data.spouse,
        };
        this.getAllDoctor();
        this.initialize();
      },
      deep: true,
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.eventHub.$on("closeMedicalInformation", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeMedicalInformation");
  },

  methods: {
    initialize() {
      // this.dataItem = [{ pregnant: "0" }];
      this.getAllPatientMedicalInfo();
      this.userRoleID = this.$store.state.user.user.user_roleID;
    },
    getAllPatientMedicalInfo() {
      this.loading = true;
      this.axiosCall(
        "/medical-info/patientMedicalInfo/" + this.data.patientID,
        "GET"
      ).then((res) => {
        if (res) {
          // console.log("Get Data", res.data);
          this.dataItem = res.data;
          this.buttonAlert = this.dataItem.some(
            (item) => String(item.pregnant) === "1"
          );
        } else {
          this.dataItem = null;
        }
        this.loading = false;
      });
    },

    getAllDoctor() {
      this.axiosCall("/user-details/getAllVerifiedUser", "GET").then((res) => {
        this.docList = res.data;
      });
    },

    getDoctor(id) {
      if (id) {
        for (let i = 0; i < this.docList.length; i++) {
          if (this.docList[i].id == id) {
            return this.docList[i].name;
          }
        }
      }
    },

    closeD() {
      this.eventHub.$emit("closeViewMedicalInformationDialog", false);
      this.dialog = false;
    },

    edit(item) {
      // console.log(item);

      this.medicalData = item;
      this.action = "Update";
    },
    view(item) {
      // console.log(item);
      Object.assign(item, { personal_details: this.personal_details });
      this.medicalData = item;
      this.action = "View";
    },

    AddFunction() {
      this.medicalData = {
        id: null,
        data: this.data,
        personal_details: this.personal_details,
      };
      this.action = "Add";
    },

    print(item) {
      console.log(item);
      console.log(this.data.name);
      const url =
        process.env.VUE_APP_SERVER +
        "/pdf-generator/patientMedicalRecord/" +
        item.id +
        "/" +
        this.data.name.replace(/\s+/g, ",");
      window.open(url);
    },
    printMeds(num) {
      if (num == 1) {
        const url =
          process.env.VUE_APP_SERVER +
          "/pdf-generator/patientNormalMedication/" +
          this.data.patientID +
          "/" +
          this.data.name.replace(/\s+/g, ",");
        window.open(url);
      } else if (num == 2) {
        const url =
          process.env.VUE_APP_SERVER +
          "/pdf-generator/patientPregnantMedication/" +
          this.data.patientID +
          "/" +
          this.data.name.replace(/\s+/g, ",");
        window.open(url);
      } else if (num == 3) {
        console.log(num);
        const url =
          process.env.VUE_APP_SERVER +
          "/pdf-generator/patientAllMedication/" +
          this.data.patientID +
          "/" +
          this.data.name.replace(/\s+/g, ",");
        window.open(url);
      }
    },
  },
};
</script>
<style scoped>
:hover.medic {
  background-color: blue;
  color: white;
}
</style>
